var map = {
	"./en/heart_1.png": "1e1b",
	"./en/heart_10.png": "fdea",
	"./en/heart_10_bj.png": "206b",
	"./en/heart_11.png": "f806",
	"./en/heart_11_bj.png": "5a73",
	"./en/heart_12.png": "8441",
	"./en/heart_12_bj.png": "ac19",
	"./en/heart_1_bj.png": "86ab",
	"./en/heart_2.png": "7c1b",
	"./en/heart_2_bj.png": "765b",
	"./en/heart_3.png": "51e4",
	"./en/heart_3_bj.png": "ecac",
	"./en/heart_4.png": "9e7c",
	"./en/heart_4_bj.png": "ab8a",
	"./en/heart_5.png": "63c7",
	"./en/heart_5_bj.png": "a27d",
	"./en/heart_6.png": "c7f0",
	"./en/heart_6_bj.png": "9ff4",
	"./en/heart_7.png": "255f",
	"./en/heart_7_bj.png": "f63e",
	"./en/heart_8.png": "b5be",
	"./en/heart_8_bj.png": "cf5a",
	"./en/heart_9.png": "691c",
	"./en/heart_9_bj.png": "ad1c",
	"./en/skull_1.png": "b836",
	"./en/skull_10.png": "eeaf",
	"./en/skull_10_bj.png": "f984",
	"./en/skull_11.png": "3509",
	"./en/skull_11_bj.png": "d706",
	"./en/skull_12.png": "74bb",
	"./en/skull_12_bj.png": "6651",
	"./en/skull_1_bj.png": "5e69",
	"./en/skull_2.png": "fb01",
	"./en/skull_2_bj.png": "15dc",
	"./en/skull_3.png": "a899",
	"./en/skull_3_bj.png": "bf6b",
	"./en/skull_4.png": "24c8",
	"./en/skull_4_bj.png": "6940",
	"./en/skull_5.png": "1c04",
	"./en/skull_5_bj.png": "c300",
	"./en/skull_6.png": "213a",
	"./en/skull_6_bj.png": "3e92",
	"./en/skull_7.png": "e361",
	"./en/skull_7_bj.png": "3287",
	"./en/skull_8.png": "7b5f",
	"./en/skull_8_bj.png": "d04a",
	"./en/skull_9.png": "0b56",
	"./en/skull_9_bj.png": "0dc5",
	"./heart_1.png": "68b2",
	"./heart_10.png": "42d4",
	"./heart_10_bj.png": "5db7",
	"./heart_11.png": "ef09",
	"./heart_11_bj.png": "ca0c",
	"./heart_12.png": "8010",
	"./heart_12_bj.png": "d6b3",
	"./heart_13.png": "0b4f",
	"./heart_13_bj.png": "2d91",
	"./heart_14.png": "65d3",
	"./heart_14_bj.png": "c7fb",
	"./heart_15.png": "7c07",
	"./heart_15_bj.png": "4745",
	"./heart_16.png": "8b19",
	"./heart_16_bj.png": "d5ac",
	"./heart_17.png": "7c7a",
	"./heart_17_bj.png": "4492",
	"./heart_18.png": "e692",
	"./heart_18_bj.png": "7883",
	"./heart_19.png": "7d52",
	"./heart_19_bj.png": "0909",
	"./heart_1_bj.png": "84ba",
	"./heart_2.png": "b591",
	"./heart_20.png": "f3de",
	"./heart_20_bj.png": "ec6e",
	"./heart_2_bj.png": "b342",
	"./heart_3.png": "6b32",
	"./heart_3_bj.png": "bcbf",
	"./heart_4.png": "7d90",
	"./heart_4_bj.png": "6efe",
	"./heart_5.png": "ad9a",
	"./heart_5_bj.png": "f0b0",
	"./heart_6.png": "e3d6",
	"./heart_6_bj.png": "ee75",
	"./heart_7.png": "0ca9",
	"./heart_7_bj.png": "5271",
	"./heart_8.png": "70fd",
	"./heart_8_bj.png": "046d",
	"./heart_9.png": "2f84",
	"./heart_9_bj.png": "2603",
	"./skull_1.png": "b38d",
	"./skull_10.png": "f7a3",
	"./skull_10_bj.png": "8281",
	"./skull_11.png": "85b5",
	"./skull_11_bj.png": "2135",
	"./skull_12.png": "8835",
	"./skull_12_bj.png": "b5ff",
	"./skull_13.png": "81db",
	"./skull_13_bj.png": "2c54",
	"./skull_14.png": "68a2",
	"./skull_14_bj.png": "5c7f",
	"./skull_15.png": "04b9",
	"./skull_15_bj.png": "9036",
	"./skull_16.png": "d72c",
	"./skull_16_bj.png": "ff91",
	"./skull_17.png": "d588",
	"./skull_17_bj.png": "c1e3",
	"./skull_18.png": "16ab",
	"./skull_18_bj.png": "4f1d",
	"./skull_19.png": "5d48",
	"./skull_19_bj.png": "9d15",
	"./skull_1_bj.png": "0ddd",
	"./skull_2.png": "04f3",
	"./skull_20.png": "75f0",
	"./skull_20_bj.png": "23bb",
	"./skull_2_bj.png": "976c",
	"./skull_3.png": "57dc",
	"./skull_3_bj.png": "5928",
	"./skull_4.png": "93b6",
	"./skull_4_bj.png": "57bc",
	"./skull_5.png": "205d",
	"./skull_5_bj.png": "b2c2",
	"./skull_6.png": "2fe8",
	"./skull_6_bj.png": "3b7a",
	"./skull_7.png": "19fe",
	"./skull_7_bj.png": "9de9",
	"./skull_8.png": "463c",
	"./skull_8_bj.png": "fbd9",
	"./skull_9.png": "63aa",
	"./skull_9_bj.png": "38ce"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e9f7";